import {combineReducers} from "redux";
import streamChannelReducer from "./streamChannelReducer";
import formReducer from "./formReducer";

const rootReducer = combineReducers({
    channels : streamChannelReducer as any,
    form : formReducer as any,
});

export default rootReducer;